import exportPdf from './exportPdf'

const audit = {
  exportPdf,
}

export default audit
